import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Download, Share, SquarePlus, X } from 'lucide-react';
import { usePwaInstall } from '../../hooks/usePwaInstall';

const InstallPrompt: React.FC = () => {
  const { shouldOffer, canPrompt, iosNeedsManualInstall, promptInstall, dismiss } = usePwaInstall();

  return (
    <AnimatePresence>
      {shouldOffer && (
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 24 }}
          transition={{ duration: 0.25, ease: 'easeOut' }}
          role="dialog"
          aria-label="Install FPL Standings"
          className="fixed inset-x-0 bottom-0 z-40 px-3 pb-[calc(env(safe-area-inset-bottom)+0.75rem)]"
        >
          <div className="mx-auto max-w-md rounded-2xl bg-surface text-content shadow-2xl ring-1 ring-line p-4">
            <div className="flex items-start gap-3">
              <img
                src="/web-app-manifest-192x192.png"
                alt=""
                className="h-11 w-11 shrink-0 rounded-xl bg-white ring-1 ring-line"
              />
              <div className="min-w-0 flex-1">
                <p className="font-semibold leading-tight">Install FPL Standings</p>
                {iosNeedsManualInstall ? (
                  <p className="mt-1 text-sm text-content-secondary">
                    Tap <Share size={14} className="inline align-[-2px]" aria-label="Share" /> in
                    Safari&apos;s toolbar, then{' '}
                    <span className="whitespace-nowrap font-medium text-content">
                      Add to Home Screen{' '}
                      <SquarePlus size={14} className="inline align-[-2px]" aria-hidden />
                    </span>
                    .
                  </p>
                ) : (
                  <p className="mt-1 text-sm text-content-secondary">
                    Add it to your home screen for full-screen access and offline standings.
                  </p>
                )}
              </div>
              <button
                type="button"
                onClick={dismiss}
                aria-label="Dismiss install prompt"
                className="inline-flex min-h-11 min-w-11 shrink-0 items-center justify-center rounded-md text-content-muted hover:bg-surface-sunken hover:text-content transition-colors"
              >
                <X size={18} />
              </button>
            </div>

            {canPrompt && (
              <button
                type="button"
                onClick={promptInstall}
                className="mt-3 inline-flex min-h-11 w-full items-center justify-center gap-2 rounded-xl bg-inverse px-4 font-medium text-inverse-content transition hover:opacity-90"
              >
                <Download size={18} />
                Install app
              </button>
            )}
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default InstallPrompt;
